import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import GetPrice from "../Functions/GetPrice";
import {
  CapitalizeAllWords,
  convertToPersian,
  NumToFa,
  capitalizeFirstLetters,
} from "../Functions/TextTransform";
import OverlayContainer from "../Components/OverlayContainer";
import {
  Accordion,
  AccordionContext,
  useAccordionButton,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import NumberToPersianWord from "number_to_persian_word";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import InnerImageZoom from "react-inner-image-zoom";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useMediaQuery } from "react-responsive";
import authHeader from "../Services/auth-header";
import { refreshToken } from "../Services/auth.service";
import RenderSideCart from "../Components/RenderSideCart";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import StaticMeasureHelps from "../Static Files/StaticMeasureHelps";
import { ShowLogin2Modal } from "../Actions/types";
import QtyCountFabric from "../Components/QtyCountFabric";
import { rgb } from "polished";
import {
  baseURLCats,
  baseURLCatProduct,
  baseURLAddProduct,
  baseURLSaveProduct,
  baseURLFreeShipping,
  baseURLGetFavorites,
  baseURLDeleteFavorite,
  baseURLJoinWaitingList,
  imgUrl,
} from "../config/api";

function ReadyMadeDraperyItem() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const { catID } = useParams();
  const { productID } = useParams();
  const { designID } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { isLoggedIn, sideCartPrice, cartUpdated, mainCart } = useSelector((state) => state.auth);

  const [completePageState, setCompletePageState] = useState(searchParams.get("C"));
  const [activeIndex, setActiveIndex] = useState(0);
  const [modals, setModals] = useState({});
  const [sideCartObjects, setSideCartObjects] = useState({});
  const [sideCartProductTotal, setSideCartProductTotal] = useState(0);
  const [sideCartInstallPrice, setSideCartInstallPrice] = useState(0);
  const [sideCartTransportPrice, setSideCartTransportPrice] = useState(0);
  const [sideCartHasSwatches, setSideCartHasSwatches] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [freeShipPrice, setFreeShipPrice] = useState(0);
  const splideRef = useRef(null);
  const [catObject, setCatObject] = useState({});
  const [productAwaitingLogin, setProductAwaitingLogin] = useState([]);
  const [catProducts, setCatProducts] = useState([]);
  const [userFavorites, setUserFavorites] = useState([]);
  const [designProducts, setDesignProducts] = useState({});
  const [activeProduct, setActiveProduct] = useState({});
  const [splidesList, setSplidesList] = useState([]);
  const [slidesList, setSlidesList] = useState([]);
  const [colorsList, setColorsList] = useState([]);
  const [sizesList, setSizesList] = useState([]);
  const [widthList, setWidthList] = useState([]);
  const [lengthList, setLengthList] = useState([]);
  const [controlsList, setControlsList] = useState([]);
  const [liningsList, setLiningsList] = useState([]);
  const [isPageComplete, setIsPageComplete] = useState(completePageState === "1");
  const [isColorSelected, setIsColorSelected] = useState(true);
  const [isSizeSelected, setIsSizeSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] === "ready-made-shade"
  );
  const [isWidthSelected, setIsWidthSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] !== "ready-made-shade"
  );
  const [isLengthSelected, setIsLengthSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] !== "ready-made-shade"
  );
  const [isControlSelected, setIsControlSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] !== "ready-made-shade"
  );
  const [isLiningSelected, setIsLiningSelected] = useState(completePageState === "1");
  const [colorError, setColorError] = useState(false);
  const [sizeError, setSizeError] = useState(false);
  const [widthError, setWidthError] = useState(false);
  const [lengthError, setLengthError] = useState(false);
  const [controlError, setControlError] = useState(false);
  const [liningError, setLiningError] = useState(false);
  const [qty, setQty] = useState(1);
  const [addingLoading, setAddingLoading] = useState(false);
  const [savingLoading, setSavingLoading] = useState(false);
  const [removingLoading, setRemovingLoading] = useState(false);
  const [toastSave, setToastSave] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [showWaitlistEmail, setShowWaitlistEmail] = useState(false);
  const [waitlistEmail, setWaitlistEmail] = useState("");
  const [waitlistEmailError, setWaitlistEmailError] = useState("");
  const [waitlistMessageType, setWaitlistMessageType] = useState("error");
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const waitlistMessageTimeoutRef = useRef(null);
  const [controlPositionText, setControlPositionText] = useState("");
  const [controlPosition, setControlPosition] = useState("");

  const stockQty = Number(activeProduct["StockQty"]) || 0;
  const maxOrderableQty = Number(activeProduct["MaxOrderableQty"]) || 10;
  const fabricSteps = activeProduct["UnitId"] === 1 ? 0.5 : 1;
  const isSoldOut = stockQty === 0 && activeProduct["OnBasket"] === false;
  const isWaitlist = stockQty === 0 && activeProduct["OnBasket"] === true;
  const fabricMaxQty =
    stockQty > 0 ? Math.round((stockQty + fabricSteps) * 100) / 100 : maxOrderableQty;
  const isOverStock = stockQty > 0 && !isSoldOut && !isWaitlist && qty > stockQty;
  // These product groups have no lining selection on this page
  const productGroupsWithoutLining = ["100202", "100203", "100204"];
  const skipLiningCheck = productGroupsWithoutLining.includes(
    String(activeProduct["ProductGroupId"])
  );

  const validateWaitlistEmail = (email) =>
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/.test(
      email
    );

  const showWaitlistMessage = (message, type = "error") => {
    if (waitlistMessageTimeoutRef.current) {
      clearTimeout(waitlistMessageTimeoutRef.current);
    }
    setWaitlistMessageType(type);
    setWaitlistEmailError(message);
    waitlistMessageTimeoutRef.current = setTimeout(() => {
      setWaitlistEmailError("");
      waitlistMessageTimeoutRef.current = null;
    }, 5000);
  };

  const isAlreadyRegisteredMessage = (message = "") =>
    /قبلاً|قبلا|already registered|already|لیست انتظار ثبت/i.test(message);

  useEffect(() => {
    return () => {
      if (waitlistMessageTimeoutRef.current) {
        clearTimeout(waitlistMessageTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setShowWaitlistEmail(false);
    setWaitlistEmail("");
    setWaitlistEmailError("");
    setWaitlistMessageType("error");
    if (waitlistMessageTimeoutRef.current) {
      clearTimeout(waitlistMessageTimeoutRef.current);
      waitlistMessageTimeoutRef.current = null;
    }
    const stock = Number(activeProduct["StockQty"]) || 0;
    const steps = activeProduct["UnitId"] === 1 ? 0.5 : 1;
    const nextMax =
      stock > 0
        ? Math.round((stock + steps) * 100) / 100
        : Number(activeProduct["MaxOrderableQty"]) || 10;
    setQty((prev) => Math.min(Math.max(prev, 1), nextMax > 0 ? nextMax : 1));
  }, [activeProduct["ProductId"]]);

  const getCatProducts = () => {
    if (searchParams.get("Product") && searchParams.get("Product") !== "") {
      axios
        .get(baseURLCats, {
          params: {
            pageName: catID,
            // apiKey: window.$apikey
          },
        })
        .then((response) => {
          setCatObject(response.data || {});
        })
        .catch((err) => {
          console.log(err);
          navigate("/" + pageLanguage);
        });
      // console.log(defDesign);
      axios
        .get(baseURLCatProduct, {
          params: {
            groupId: productID,
            designs: designID,
            // apiKey: window.$apikey
          },
        })
        .then((response) => {
          if (response.data && response.data["Products"].length) {
            setCatProducts(response.data["Products"]);
          } else {
            setCatProducts({});
            setDesignProducts({});
            navigate("/" + pageLanguage);
          }
        })
        .catch((err) => {
          console.log(err);
          navigate("/" + pageLanguage);
        });
    } else {
      navigate("/" + pageLanguage);
    }
  };

  function getFavorites() {
    axios
      .get(baseURLGetFavorites, {
        headers: authHeader(),
      })
      .then((response) => {
        if (isLoggedIn && !response.data?.length && productAwaitingLogin.length) {
          saveProduct(productAwaitingLogin[0], productAwaitingLogin[1], true);
          setProductAwaitingLogin([]);
        }
        setUserFavorites(response.data || []);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getFavorites();
            } else {
              // navigate("/" + pageLanguage);
            }
          });
        } else {
          setUserFavorites([]);
        }
      });
  }

  function modalHandleClose(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = false;
    setModals(tempModals);
  }

  function modalHandleShow(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = true;
    setModals(tempModals);
  }

  function getActiveColorProducts() {
    let tempActiveProduct =
      catProducts.find((obj) => obj["ProductId"] === searchParams.get("Product")) || {};

    if (Object.keys(tempActiveProduct).length === 0) {
      navigate("/" + pageLanguage);
    } else {
      let filteredProducts = catProducts.filter(
        (obj) => obj["SewingModelId"] === tempActiveProduct["SewingModelId"]
      );
      let temp = {};
      let promiseArr = [];
      filteredProducts.forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          if (
            temp[obj["ColorId"]] === "" ||
            temp[obj["ColorId"]] === undefined ||
            temp[obj["ColorId"]] === null ||
            temp[obj["ColorId"]].length === 0
          ) {
            temp[obj["ColorId"]] = [];
          }
          temp[obj["ColorId"]].push(obj);
          resolve();
        });
      });

      Promise.all(promiseArr).then(() => {
        setDesignProducts(temp);

        setActiveProduct(tempActiveProduct);
      });
    }
  }

  function renderPageContent() {
    if (Object.keys(designProducts).length) {
      let isReadyMadeShade = location.pathname.split("/")[2] === "ready-made-shade";
      let temp = [];
      let temp2 = {};
      let temp3 = [];
      let temp4 = [];
      let temp5 = {};
      let temp6 = {};
      let temp7 = {};
      let temp8 = {};
      let promiseArr = [];

      function getControlImg(controlText, productGroupId, sewingModelId) {
        if (productGroupId === "100202") {
          return controlText === "Right"
            ? require("../Images/drapery/zebra/position_right.svg").default
            : require("../Images/drapery/zebra/position_left.svg").default;
        }
        if (productGroupId === "100203" || productGroupId === "100205") {
          if (sewingModelId === "0327") {
            return controlText === "Right"
              ? require("../Images/drapery/roller/pleated_right.svg").default
              : require("../Images/drapery/roller/pleated_left.svg").default;
          }
          if (sewingModelId === "0097") {
            return controlText === "Right"
              ? require("../Images/drapery/roller/flat_right.svg").default
              : require("../Images/drapery/roller/flat_left.svg").default;
          }
          if (sewingModelId === "0328") {
            return controlText === "Right"
              ? require("../Images/drapery/roller/soft_right.svg").default
              : require("../Images/drapery/roller/soft_left.svg").default;
          }
          return controlText === "Right"
            ? require("../Images/drapery/roller/windowLeft.svg").default
            : require("../Images/drapery/roller/windowRight.svg").default;
        }
        if (productGroupId === "100204") {
          return controlText === "Right"
            ? require("../Images/drapery/zebra/right_img.svg").default
            : require("../Images/drapery/zebra/left_img.svg").default;
        }
        return undefined;
      }

      Object.keys(designProducts).forEach((key, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let ProductId = designProducts[key][0]["ProductId"];
          let ColorEnName = CapitalizeAllWords(designProducts[key][0]["ColorEnName"]);
          let ColorName = convertToPersian(designProducts[key][0]["ColorName"]);
          let ColorPhotoPath =
            designProducts[key][0]["Photos"].find((obj) => obj.PhotoTypeId === 4709)?.PhotoUrl ||
            "";
          let isActiveColor = designProducts[key]
            .map(function(obj) {
              return obj["ProductId"];
            })
            .filter((n) => n)
            .includes(searchParams.get("Product"));

          temp.push(
            <li
              key={"color" + ProductId + index}
              className={`rmd_info_colors_list_item Accessories_List_item_colors_list_item ${
                isColorSelected && isActiveColor ? "colorSelected" : ""
              }`}
              onClick={() => {
                if (controlPosition != controlPositionText) {
                  setControlError(true);
                  setControlPosition("");
                }
                if (!isColorSelected) {
                  setIsColorSelected(true);
                }
                setSearchParams("?Product=" + ProductId);
                setIsWidthSelected(false);
                setIsLengthSelected(false);
                setIsLiningSelected(false);
              }}
            >
              <OverlayContainer
                classNames="Accessories_List_item_color"
                placement="middle"
                children={
                  <div
                    className="Accessories_List_item_colors_list_item_overlay"
                    style={{
                      background: `transparent url(${imgUrl(ColorPhotoPath.trim())}) no-repeat`,
                    }}
                  />
                }
                component={
                  <div className="Accessories_List_item_color_container">
                    <p className="Accessories_List_item_color_text">
                      {pageLanguage === "en" ? ColorEnName : ColorName}
                    </p>
                  </div>
                }
              />
            </li>
          );

          let promiseArr2 = [];
          designProducts[key].forEach((obj, i) => {
            promiseArr2[i] = new Promise((resolve) => {
              let isActiveProduct = obj["ProductId"] === searchParams.get("Product");
              let sizeText = obj["ProductSizeEnName"];
              let sizeTextFa = obj["ProductSizeName"];
              if (temp2[sizeText] === undefined || isActiveProduct) {
                temp2[sizeText] = (
                  <li
                    key={"size" + ProductId + i}
                    className={`rmd_info_btn_list_item ${
                      isActiveColor
                        ? isSizeSelected && isActiveProduct
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className="btn"
                      onClick={() => {
                        if (!isSizeSelected) {
                          setIsSizeSelected(true);
                        }
                        setSearchParams("?Product=" + obj["ProductId"]);
                      }}
                    >
                      {pageLanguage === "fa" ? sizeTextFa : sizeText}
                    </button>
                  </li>
                );
              }
              let isActiveLining = obj["ProductId"] === searchParams.get("Product");
              if (obj["ProductGroupId"] !== "100205" && obj["LiningTypeId"] != null) {
                let liningTypeId = obj["LiningTypeId"];
                if (temp5[liningTypeId] === undefined || isActiveLining) {
                  temp5[liningTypeId] = (
                    <li
                      key={"lining" + ProductId + i}
                      className={`rmd_info_btn_list_item ${
                        isActiveColor
                          ? isLiningSelected && activeProduct["LiningTypeId"] === liningTypeId
                            ? "btnSelected"
                            : ""
                          : "crossed"
                      }`}
                    >
                      <button
                        className="btn"
                        onClick={() => {
                          if (!isLiningSelected) {
                            setIsLiningSelected(true);
                          }
                          setSearchParams("?Product=" + obj["ProductId"]);
                        }}
                      >
                        {pageLanguage === "fa" ? obj["LiningTypeName"] : obj["LiningTypeEnName"]}
                      </button>
                    </li>
                  );
                }
              }

              let widthText = obj["Width"];
              if (!isReadyMadeShade && (temp6[widthText] === undefined || isActiveProduct)) {
                temp6[widthText] = (
                  <li
                    key={"Width" + ProductId + i}
                    className={`rmd_info_btn_list_item ${
                      isActiveColor
                        ? isWidthSelected && isActiveProduct
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className={`btn btn-group`}
                      onClick={() => {
                        if (controlPosition !== controlPositionText) {
                          setControlError(true);
                          setControlPosition("");
                        }
                        setControlPositionText("");
                        setIsControlSelected(false);
                        if (!isWidthSelected) {
                          setIsWidthSelected(true);
                        }
                        setSearchParams("?Product=" + obj["ProductId"]);
                      }}
                    >
                      {NumToFa(widthText + t("Measurements CM"), pageLanguage)}
                    </button>
                  </li>
                );
              }

              let lengthText = obj["Length"];
              if (!isReadyMadeShade && (temp7[lengthText] === undefined || isActiveProduct)) {
                temp7[lengthText] = (
                  <li
                    key={"Length" + ProductId + i}
                    className={`rmd_info_btn_list_item ${
                      isActiveColor
                        ? isLengthSelected && isActiveProduct
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className={`btn btn-group`}
                      onClick={() => {
                        if (controlPosition !== controlPositionText) {
                          setControlError(true);
                          setControlPosition("");
                        }
                        setControlPositionText("");
                        setIsControlSelected(false);
                        if (!isLengthSelected) {
                          setIsLengthSelected(true);
                        }
                        setSearchParams("?Product=" + obj["ProductId"]);
                      }}
                    >
                      {NumToFa(lengthText + t("Measurements CM"), pageLanguage)}
                    </button>
                  </li>
                );
              }

              let promiseArr3 = [];
              if (isActiveProduct) {
                let tempPhotosArr = [
                  obj["Photos"].find((obj) => obj.PhotoTypeId === 4702)?.PhotoUrl,
                ];
                tempPhotosArr.push(
                  ...obj["Photos"]
                    .map(function(object) {
                      if (object["PhotoTypeId"] !== 4702 && object["PhotoTypeId"] !== 4709) {
                        return object["PhotoUrl"];
                      } else {
                        return undefined;
                      }
                    })
                    .filter((n) => n)
                );
                tempPhotosArr.forEach((el, j) => {
                  promiseArr3[j] = new Promise((resolve, reject) => {
                    temp3.push(
                      <SplideSlide key={"splide" + ProductId + j} onClick={() => setActiveIndex(j)}>
                        <img className="img-fluid" src={imgUrl(el)} alt={"Image" + j} />
                      </SplideSlide>
                    );
                    temp4.push(
                      <Carousel.Item key={"slide" + obj["ProductId"] + j} className="unselectable">
                        <InnerImageZoom
                          src={imgUrl(el)}
                          zoomSrc={imgUrl(el)}
                          zoomType="none"
                          hideHint={true}
                        />
                      </Carousel.Item>
                    );
                    resolve();
                  });
                });
              }
              Promise.all(promiseArr3).then(() => {
                resolve();
              });
            });
          });
          Promise.all(promiseArr2).then(() => {
            if (isActiveColor && isReadyMadeShade) {
              let colorProducts = designProducts[key];
              let allProducts = Object.values(designProducts).flat();
              let allWidths = [...new Set(allProducts.map((p) => p["Width"]))].sort(
                (a, b) => a - b
              );
              let allLengths = [...new Set(allProducts.map((p) => p["Length"]))].sort(
                (a, b) => a - b
              );
              let selectedWidth = isWidthSelected ? activeProduct["Width"] : null;

              allWidths.forEach((widthVal) => {
                let hasWidth = colorProducts.some((p) => p["Width"] === widthVal);
                let productForWidth =
                  colorProducts.find(
                    (p) =>
                      p["Width"] === widthVal &&
                      (isLengthSelected ? p["Length"] === activeProduct["Length"] : true) &&
                      (isLiningSelected
                        ? p["LiningTypeId"] === activeProduct["LiningTypeId"]
                        : true) &&
                      (isControlSelected && controlPositionText
                        ? (p["ControlPosition"] ? "Right" : "Left") === controlPositionText
                        : true)
                  ) ||
                  colorProducts.find(
                    (p) =>
                      p["Width"] === widthVal &&
                      (isLengthSelected ? p["Length"] === activeProduct["Length"] : true) &&
                      (isLiningSelected
                        ? p["LiningTypeId"] === activeProduct["LiningTypeId"]
                        : true)
                  ) ||
                  colorProducts.find(
                    (p) =>
                      p["Width"] === widthVal &&
                      (isLengthSelected ? p["Length"] === activeProduct["Length"] : true)
                  ) ||
                  colorProducts.find((p) => p["Width"] === widthVal);

                temp6[widthVal] = (
                  <li
                    key={"Width" + key + widthVal}
                    className={`rmd_info_btn_list_item ${
                      hasWidth
                        ? isWidthSelected && activeProduct["Width"] === widthVal
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className={`btn btn-group`}
                      onClick={() => {
                        if (!hasWidth || !productForWidth) {
                          return;
                        }
                        if (controlPosition !== controlPositionText) {
                          setControlError(true);
                          setControlPosition("");
                        }
                        setControlPositionText("");
                        setIsControlSelected(false);
                        if (
                          isLiningSelected &&
                          productForWidth &&
                          productForWidth["LiningTypeId"] !== activeProduct["LiningTypeId"]
                        ) {
                          setIsLiningSelected(false);
                        }
                        if (productForWidth["Length"] !== activeProduct["Length"]) {
                          setIsLengthSelected(false);
                        }
                        if (!isWidthSelected) {
                          setIsWidthSelected(true);
                        }
                        setSearchParams("?Product=" + productForWidth["ProductId"]);
                      }}
                    >
                      {NumToFa(widthVal + t("Measurements CM"), pageLanguage)}
                    </button>
                  </li>
                );
              });

              allLengths.forEach((lengthVal) => {
                let hasLength = selectedWidth
                  ? colorProducts.some(
                      (p) => p["Width"] === selectedWidth && p["Length"] === lengthVal
                    )
                  : colorProducts.some((p) => p["Length"] === lengthVal);
                let productForLength = selectedWidth
                  ? colorProducts.find(
                      (p) =>
                        p["Width"] === selectedWidth &&
                        p["Length"] === lengthVal &&
                        (isLiningSelected
                          ? p["LiningTypeId"] === activeProduct["LiningTypeId"]
                          : true) &&
                        (isControlSelected && controlPositionText
                          ? (p["ControlPosition"] ? "Right" : "Left") === controlPositionText
                          : true)
                    ) ||
                    colorProducts.find(
                      (p) =>
                        p["Width"] === selectedWidth &&
                        p["Length"] === lengthVal &&
                        (isLiningSelected
                          ? p["LiningTypeId"] === activeProduct["LiningTypeId"]
                          : true)
                    ) ||
                    colorProducts.find(
                      (p) => p["Width"] === selectedWidth && p["Length"] === lengthVal
                    )
                  : colorProducts.find((p) => p["Length"] === lengthVal);

                temp7[lengthVal] = (
                  <li
                    key={"Length" + key + lengthVal}
                    className={`rmd_info_btn_list_item ${
                      hasLength
                        ? isLengthSelected && activeProduct["Length"] === lengthVal
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className={`btn btn-group`}
                      onClick={() => {
                        if (!hasLength || !productForLength) {
                          return;
                        }
                        if (controlPosition !== controlPositionText) {
                          setControlError(true);
                          setControlPosition("");
                        }
                        setControlPositionText("");
                        setIsControlSelected(false);
                        if (
                          isLiningSelected &&
                          productForLength &&
                          productForLength["LiningTypeId"] !== activeProduct["LiningTypeId"]
                        ) {
                          setIsLiningSelected(false);
                        }
                        if (!isLengthSelected) {
                          setIsLengthSelected(true);
                        }
                        setSearchParams("?Product=" + productForLength["ProductId"]);
                      }}
                    >
                      {NumToFa(lengthVal + t("Measurements CM"), pageLanguage)}
                    </button>
                  </li>
                );
              });

              let hasKnownSize =
                (isWidthSelected || allWidths.length <= 1) &&
                (isLengthSelected || allLengths.length <= 1);
              let applyControlAvailability = hasKnownSize || isLiningSelected;
              let productsForCurrentSize = designProducts[key].filter(
                (p) =>
                  p["Width"] === activeProduct["Width"] &&
                  p["Length"] === activeProduct["Length"] &&
                  (!isLiningSelected || p["LiningTypeId"] === activeProduct["LiningTypeId"])
              );
              let hasLeftOption = productsForCurrentSize.some((p) => !p["ControlPosition"]);
              let hasRightOption = productsForCurrentSize.some((p) => p["ControlPosition"]);
              let activeProductGroupId = activeProduct["ProductGroupId"];

              ["Left", "Right"].forEach((controlText) => {
                let matchingProductForControl = productsForCurrentSize.find(
                  (p) => (p["ControlPosition"] ? "Right" : "Left") === controlText
                );
                let isControlAvailable = applyControlAvailability
                  ? controlText === "Left"
                    ? hasLeftOption
                    : hasRightOption
                  : true;
                let controlImg = getControlImg(
                  controlText,
                  activeProductGroupId,
                  activeProduct["SewingModelId"]
                );

                temp8[controlText] = (
                  <li
                    key={"ControlPosition" + controlText + key}
                    className={`rmd_info_cp_list_item img_box ${
                      isControlAvailable && controlPositionText === controlText
                        ? "colorSelected"
                        : ""
                    }`}
                    onClick={() => {
                      if (!isControlAvailable || !matchingProductForControl) {
                        return;
                      }
                      setControlPositionText(controlText);
                      setControlPosition(controlText);
                      setControlError(false);
                      if (!isControlSelected) {
                        setIsControlSelected(true);
                      }
                      setSearchParams("?Product=" + matchingProductForControl["ProductId"]);
                    }}
                    style={
                      isControlAvailable
                        ? {}
                        : {
                            pointerEvents: "none",
                            opacity: "0.5",
                          }
                    }
                  >
                    {activeProductGroupId === "100202" && (
                      <div
                        className="rmd_info_cp_list_item_img_container"
                        style={{ position: "relative", height: "10.325rem" }}
                      >
                        <img
                          src={controlImg}
                          className="img-fluid"
                          style={{ height: "9rem" }}
                          alt=""
                        />
                        <p
                          className="rmd_info_cp_list_item_img_title"
                          style={{
                            position: "absolute",
                            bottom: "0.10rem",
                            left: "50%",
                            transform: "translateX(-50%)",
                          }}
                        >
                          {t(controlText)}
                        </p>
                      </div>
                    )}
                    {activeProductGroupId === "100203" && (
                      <div
                        className="rmd_info_cp_list_item_container"
                        style={{
                          position: "relative",
                          height: "10.325rem",
                          padding: "0 0.5rem",
                        }}
                      >
                        <img
                          src={controlImg}
                          className="img-fluid"
                          style={{ height: "9rem" }}
                          alt=""
                        />
                        <p
                          className="rmd_info_cp_list_item_img_title"
                          style={{
                            position: "absolute",
                            bottom: "0.10rem",
                            left: "50%",
                            transform: "translateX(-50%)",
                          }}
                        >
                          {t(controlText)}
                        </p>
                      </div>
                    )}
                    {activeProductGroupId === "100205" && (
                      <div
                        className="rmd_info_cp_list_item_container"
                        style={{
                          position: "relative",
                          height: "10.325rem",
                          padding: "0 0.5rem",
                        }}
                      >
                        <img
                          src={controlImg}
                          className="img-fluid"
                          style={{ height: "9rem" }}
                          alt=""
                        />
                        <p
                          className="rmd_info_cp_list_item_img_title"
                          style={{
                            position: "absolute",
                            bottom: "0.10rem",
                            left: "50%",
                            transform: "translateX(-50%)",
                          }}
                        >
                          {t(controlText)}
                        </p>
                      </div>
                    )}
                    {activeProductGroupId === "100204" && (
                      <div
                        className=""
                        style={{
                          position: "relative",
                          height: "10.325rem",
                          backgroundColor: rgb(247, 247, 247),
                        }}
                      >
                        <img
                          src={controlImg}
                          className="img-fluid"
                          style={{ height: "9.3rem", padding: "0.5rem", width: "128px" }}
                          alt=""
                        />
                        <p
                          className="rmd_info_cp_list_item_img_title"
                          style={{
                            position: "absolute",
                            bottom: "0.10rem",
                            left: "50%",
                            transform: "translateX(-50%)",
                          }}
                        >
                          {t(controlText)}
                        </p>
                      </div>
                    )}
                  </li>
                );
              });
            }

            if (isActiveColor && designProducts[key][0]["ProductGroupId"] === "100205") {
              let colorProducts = designProducts[key];
              let liningTypeMap = {};
              catProducts
                .filter((p) => p["SewingModelId"] === activeProduct["SewingModelId"])
                .forEach((p) => {
                  if (p["LiningTypeId"] != null && liningTypeMap[p["LiningTypeId"]] === undefined) {
                    liningTypeMap[p["LiningTypeId"]] = {
                      LiningTypeId: p["LiningTypeId"],
                      LiningTypeName: p["LiningTypeName"],
                      LiningTypeEnName: p["LiningTypeEnName"],
                    };
                  }
                });
              let uniqueLiningTypes = Object.values(liningTypeMap).sort(
                (a, b) => a.LiningTypeId - b.LiningTypeId
              );

              if (uniqueLiningTypes.length > 1) {
                let colorWidths = [...new Set(colorProducts.map((p) => p["Width"]))];
                let colorLengths = [...new Set(colorProducts.map((p) => p["Length"]))];
                let applyLiningAvailability =
                  (isWidthSelected || colorWidths.length <= 1) &&
                  (isLengthSelected || colorLengths.length <= 1);

                uniqueLiningTypes.forEach((liningType) => {
                  let liningTypeId = liningType.LiningTypeId;
                  let productsForCurrentSelection = colorProducts.filter((p) => {
                    let matchesWidth = !isWidthSelected || p["Width"] === activeProduct["Width"];
                    let matchesLength =
                      !isLengthSelected || p["Length"] === activeProduct["Length"];
                    return matchesWidth && matchesLength;
                  });
                  let isLiningAvailable = applyLiningAvailability
                    ? productsForCurrentSelection.some((p) => p["LiningTypeId"] === liningTypeId)
                    : colorProducts.some((p) => p["LiningTypeId"] === liningTypeId);
                  let productForLining = applyLiningAvailability
                    ? productsForCurrentSelection.find((p) => p["LiningTypeId"] === liningTypeId)
                    : colorProducts.find((p) => p["LiningTypeId"] === liningTypeId);
                  let liningLabel =
                    pageLanguage === "fa" ? liningType.LiningTypeName : liningType.LiningTypeEnName;
                  let isLiningActive =
                    isLiningSelected && activeProduct["LiningTypeId"] === liningTypeId;

                  temp5[liningTypeId] = (
                    <li
                      key={"lining" + key + liningTypeId}
                      className={`rmd_info_btn_list_item ${
                        isLiningAvailable ? (isLiningActive ? "btnSelected" : "") : "crossed"
                      }`}
                    >
                      <button
                        className="btn"
                        onClick={() => {
                          if (!isLiningAvailable || !productForLining) {
                            return;
                          }
                          let productToSelect =
                            isControlSelected && controlPositionText
                              ? colorProducts.find(
                                  (p) =>
                                    p["Width"] === activeProduct["Width"] &&
                                    p["Length"] === activeProduct["Length"] &&
                                    p["LiningTypeId"] === liningTypeId &&
                                    (p["ControlPosition"] ? "Right" : "Left") ===
                                      controlPositionText
                                ) || productForLining
                              : productForLining;
                          if (!isLiningSelected) {
                            setIsLiningSelected(true);
                          }
                          setLiningError(false);
                          setSearchParams("?Product=" + productToSelect["ProductId"]);
                        }}
                      >
                        {liningLabel}
                      </button>
                    </li>
                  );
                });
              }
            }
            resolve();
          });
        });
      });

      Promise.all(promiseArr).then(() => {
        setColorsList(temp);
        setSizesList(
          Object.keys(temp2)
            .sort()
            .map((key) => temp2[key])
        );
        setLiningsList(
          Object.keys(temp5)
            .sort((a, b) => Number(a) - Number(b))
            .map((liningKey) => temp5[liningKey])
        );
        setWidthList(
          Object.keys(temp6)
            .sort((a, b) => Number(a) - Number(b))
            .map((widthKey) => temp6[widthKey])
        );
        setLengthList(
          Object.keys(temp7)
            .sort((a, b) => Number(a) - Number(b))
            .map((lengthKey) => temp7[lengthKey])
        );
        if (Object.keys(temp8).length > 1) {
          setControlsList([temp8["Left"], temp8["Right"]]);
        } else {
          setControlsList(Object.values(temp8));
        }
        setSplidesList(temp3);
        setSlidesList(temp4);
      });
    } else {
      setColorsList([]);
      setSizesList([]);
      setLiningsList([]);
      setWidthList([]);
      setLengthList([]);
      setSlidesList([]);
      setSplidesList([]);
    }
  }

  function ContextAwareToggleFilters({ eventKey, callback, textOnHide, textOnShow }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        <button
          className="product_desc_accordion_btn"
          aria-expanded={`${isCurrentEventKey}`}
          type="button"
          onClick={decoratedOnClick}
        >
          <p className="product_desc_accordion_btn_title">
            {isCurrentEventKey ? textOnShow : textOnHide}
          </p>
          <div
            className={
              isCurrentEventKey
                ? "product_accordion_btn_arrow_up img-fluid"
                : "product_accordion_btn_arrow_down img-fluid"
            }
          ></div>
        </button>
      </>
    );
  }

  function joinWaitingList() {
    if (!validateWaitlistEmail(waitlistEmail.trim())) {
      showWaitlistMessage(t("Please enter a valid email"), "error");
      return;
    }

    setWaitlistEmailError("");
    setWaitlistLoading(true);

    axios
      .post(baseURLJoinWaitingList, {
        ProductId: activeProduct["ProductId"],
        Qty: qty,
        Email: waitlistEmail.trim(),
      })
      .then((response) => {
        setWaitlistLoading(false);
        const apiMessage =
          response.data?.Message ||
          response.data?.Errors?.[0]?.Message ||
          "";

        if (response.data?.Success === false || isAlreadyRegisteredMessage(apiMessage)) {
          showWaitlistMessage(
            t("You have already registered for a notification for this item."),
            "error"
          );
          return;
        }

        showWaitlistMessage(t("Your request has been successfully registered"), "success");
      })
      .catch((err) => {
        console.log(err);
        setWaitlistLoading(false);
        const apiMessage =
          err.response?.data?.Message ||
          err.response?.data?.Errors?.[0]?.Message ||
          "";

        if (isAlreadyRegisteredMessage(apiMessage) || err.response?.data?.Success === false) {
          showWaitlistMessage(
            t("You have already registered for a notification for this item."),
            "error"
          );
          return;
        }

        showWaitlistMessage(apiMessage || t("Please enter a valid email"), "error");
      });
  }

  function updateSideCartSummary(cartObjects) {
    if (!cartObjects || !Object.keys(cartObjects).length) {
      setSideCartProductTotal(0);
      setSideCartInstallPrice(0);
      setSideCartTransportPrice(0);
      setSideCartHasSwatches(false);
      return;
    }

    if (isLoggedIn && cartObjects["CartDetails"]) {
      setSideCartProductTotal(cartObjects["TotalAmount"] || 0);
      setSideCartInstallPrice(cartObjects["InstallAmount"] || 0);
      setSideCartTransportPrice(cartObjects["TransportationAmount"] || 0);
      setSideCartHasSwatches(
        cartObjects["CartDetails"].some((item) => item["TypeId"] === 6402)
      );
      return;
    }

    const draperies = cartObjects["drapery"] || [];
    const products = cartObjects["product"] || [];
    const swatches = cartObjects["swatches"] || [];
    let productTotal = 0;
    let installTotal = 0;

    [...draperies, ...products].forEach((item) => {
      const priceToUse =
        item["DiscountedPrice"] !== undefined && item["DiscountedPrice"] !== null
          ? item["DiscountedPrice"]
          : item["Price"];
      productTotal += (priceToUse || 0) * (item["Count"] || 1);
    });

    draperies.forEach((item) => {
      const installAmount = item["InstallAmount"] || 0;
      const windowCount = item["WindowCount"] || item["Count"] || 1;
      installTotal += installAmount * windowCount;
    });

    const transportItem = draperies.find((item) => item["TransportationAmount"] > 0);
    setSideCartProductTotal(productTotal);
    setSideCartInstallPrice(installTotal);
    setSideCartTransportPrice(transportItem ? transportItem["TransportationAmount"] : 0);
    setSideCartHasSwatches(swatches.length > 0);
  }

  function addProduct(product, count) {
  

    if (isLoggedIn) {
      axios.post(
          baseURLAddProduct,
          {},
          {
            headers: authHeader(),
            params: {
              productId: product["ProductId"],
              count: count,
            },
          }
        )
        .then((response) => {
          setSideCartObjects(response.data || {});
          updateSideCartSummary(response.data || {});
          setCartCount(response.data?.CartDetails?.length || 0);
          modalHandleShow("cart_modal");
          setAddingLoading(false);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                addProduct(product, count);
              } else {
                addProduct(product, count);
              }
            });
          } else {
            setAddingLoading(false);
          }
        });
    } else {
      let customPageCart = {};
      product["Count"] = parseInt(count);
      product["PhotoUrl"] =
        product["Photos"]?.find((obj) => obj.PhotoTypeId === 4702)?.PhotoUrl || "";
      if (localStorage.getItem("cart") === null) {
        let newCartObj = {};
        let newCartArr = [];
        newCartArr[0] = product;
        newCartObj["drapery"] = [];
        newCartObj["drapery"] = newCartArr;
        newCartObj["swatches"] = [];
        localStorage.setItem("cart", JSON.stringify(newCartObj));
        customPageCart = newCartObj;
      } else {
        let cartObj = JSON.parse(localStorage.getItem("cart"));
        if (cartObj["drapery"] === undefined || cartObj["drapery"].length === 0) {
          let newCartArr = [];
          newCartArr[0] = product;
          cartObj["drapery"] = newCartArr;
          localStorage.setItem("cart", JSON.stringify(cartObj));
          customPageCart = cartObj;
        } else {
          let tempProjectContainerIndex = cartObj["drapery"].findIndex(
            (obj) => obj["ProductId"] === product["ProductId"]
          );
          if (tempProjectContainerIndex !== -1) {
            if (cartObj["drapery"][tempProjectContainerIndex]) {
              cartObj["drapery"][tempProjectContainerIndex]["Count"] =
                cartObj["drapery"][tempProjectContainerIndex]["Count"] + parseInt(count);

              let updatedProduct = cartObj["drapery"].splice(tempProjectContainerIndex, 1)[0];

              cartObj["drapery"].push(updatedProduct);

              localStorage.setItem("cart", JSON.stringify(cartObj));
              customPageCart = cartObj;
            } else {
              customPageCart = cartObj;
            }
          } else {
            cartObj["drapery"].push(product);
            localStorage.setItem("cart", JSON.stringify(cartObj));
            customPageCart = cartObj;
          }
        }
      }
      setSideCartObjects(customPageCart);
      updateSideCartSummary(customPageCart);
      let cartCount = customPageCart["drapery"]?.length || 0;
      // cartCount += customPageCart["product"]?.length || 0;
      setCartCount(parseInt(cartCount) || 0);
      modalHandleShow("cart_modal");
      setAddingLoading(false);
    }
  }

  function saveProduct(product, isCompleted, forceAdd) {
    // console.log(product, count);
    setShowToast(false);
    let cartObj = {};
    let temp = [];
    if (isLoggedIn) {
      let tempIndex = userFavorites.findIndex(
        (obj) => obj.ProductId === activeProduct["ProductId"] && obj.IsComplete === isCompleted
      );
      // if(!forceAdd && tempIndex>-1 && (userFavorites[tempIndex]["IsComplete"] || !isCompleted)){
      if (!forceAdd && tempIndex > -1) {
        setToastSave(false);
        setRemovingLoading(true);
        removeProject(userFavorites[tempIndex]["FavoriteProductId"]);
      } else {
        setToastSave(true);
        setSavingLoading(true);
        axios
          .get(baseURLSaveProduct, {
            headers: authHeader(),
            params: {
              id: product["ProductId"],
              pageName: catID,
              isComplete: isCompleted,
            },
          })
          .then((response) => {
            setUserFavorites(response.data || []);
            setSavingLoading(false);

            setShowToast(true);
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  saveProduct(product, isCompleted);
                } else {
                  saveProduct(product, isCompleted);
                }
              });
            } else {
              setSavingLoading(false);
            }
          });
      }
    } else {
      setProductAwaitingLogin([product, isCompleted]);
      dispatch({
        type: ShowLogin2Modal,
      });
    }
  }

  function removeProject(id) {
    axios
      .delete(baseURLDeleteFavorite, {
        params: {
          id: id,
        },
        headers: authHeader(),
      })
      .then((response) => {
        // getFavorites();
        setUserFavorites(response.data || []);
        setRemovingLoading(false);
        setShowToast(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              removeProject(id);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        } else {
          setRemovingLoading(false);
        }
      });
  }

  useEffect(() => {
    if (!catProducts.length) {
      return;
    }
    let tempActiveProduct =
      catProducts.find((obj) => obj["ProductId"] === searchParams.get("Product")) || {};
    if (!tempActiveProduct["SewingModelId"]) {
      return;
    }
    let filteredProducts = catProducts.filter(
      (p) => p["SewingModelId"] === tempActiveProduct["SewingModelId"]
    );
    let liningTypeIds = [
      ...new Set(
        filteredProducts
          .map((p) => p["LiningTypeId"])
          .filter((liningTypeId) => liningTypeId != null)
      ),
    ];
    if (liningTypeIds.length <= 1 && tempActiveProduct["ProductGroupId"] === "100205") {
      setIsLiningSelected(true);
    }
  }, [catProducts, searchParams.get("Product")]);

  useEffect(() => {
    renderPageContent();
  }, [designProducts]);

  useEffect(() => {
    if (catProducts.length) {
      // setTimeout(() => {
      getActiveColorProducts();
      // }, 300);
    }
    if (isColorSelected) {
      setColorError(false);
    }
    if (isSizeSelected) {
      setSizeError(false);
    }

    if (
      !(
        !(isColorSelected || colorsList.length === 1) ||
        !(isSizeSelected || sizesList.length === 1) ||
        !(isWidthSelected || widthList.length === 1) ||
        !(isLengthSelected || lengthList.length === 1) ||
        !(isControlSelected || controlsList.length === 1) ||
        !(skipLiningCheck || isLiningSelected || liningsList.length <= 1)
      )
    ) {
      setIsPageComplete(true);
    } else {
      setIsPageComplete(false);
    }
  }, [
    catProducts,
    searchParams.get("Product"),
    isColorSelected,
    isSizeSelected,
    isWidthSelected,
    isLengthSelected,
    isLiningSelected,
    isControlSelected,
    liningsList.length,
  ]);

  useEffect(() => {
    if (slidesList.length) {
      setActiveIndex(0);
    }
  }, [slidesList]);

  useEffect(() => {
    if (isLoggedIn && userFavorites.length && productAwaitingLogin.length) {
      saveProduct(productAwaitingLogin[0], productAwaitingLogin[1], true);
      setProductAwaitingLogin([]);
    }
  }, [userFavorites]);

  useEffect(() => {
    // console.log(activeIndex);
    if (splideRef.current) {
      splideRef.current.go(activeIndex);
    }
  }, [activeIndex]);

  useEffect(() => {
    if (pageLanguage !== "") {
      getCatProducts();
      window.scrollTo(0, 0);
    }
  }, [pageLanguage, location.pathname]);

  useEffect(() => {
    if (isLoggedIn) {
      getFavorites();
    } else {
      setUserFavorites([]);
    }
  }, [location.pathname, isLoggedIn]);

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!isControlSelected || !controlPositionText || !activeProduct["ProductId"]) {
      return;
    }
    let activeControlText = activeProduct["ControlPosition"] ? "Right" : "Left";
    if (controlPositionText !== activeControlText) {
      setControlPosition("");
      setControlPositionText("");
      setIsControlSelected(false);
    }
  }, [activeProduct["ProductId"], activeProduct["ControlPosition"]]);

  useEffect(() => {
    renderPageContent();
  }, [
    activeProduct["SewingModelId"],
    activeProduct["Width"],
    activeProduct["Length"],
    activeProduct["ProductId"],
    isWidthSelected,
    isLengthSelected,
    controlPositionText,
    isLiningSelected,
    isControlSelected,
  ]);

  useEffect(() => {
    if (cartUpdated) {
      if (mainCart && Object.keys(mainCart).length) {
        updateSideCartSummary(mainCart);
        setSideCartObjects(mainCart);
      } else if (!isLoggedIn && localStorage.getItem("cart")) {
        updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
      }
    }
  }, [cartUpdated]);

  useEffect(() => {
    if (!isLoggedIn && modals["cart_modal"] && localStorage.getItem("cart")) {
      updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
    }
  }, [sideCartPrice, modals, isLoggedIn]);

  useEffect(() => {
    if (sideCartObjects.drapery) {
      setCartCount(sideCartObjects.drapery?.length || 0);
    }
  }, [sideCartObjects]);

  useEffect(() => {
    axios
    .get(baseURLFreeShipping)
    .then((response) => {
      setFreeShipPrice(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
  }, []);

  let activeControlText = activeProduct["ControlPosition"] ? "Right" : "Left";
  let isControlConfirmed =
    isControlSelected && controlPositionText !== "" && controlPositionText === activeControlText;

  const isProductConfigurationComplete =
    (isColorSelected || colorsList.length === 1) &&
    (isSizeSelected || sizesList.length === 1) &&
    (isWidthSelected || widthList.length === 1) &&
    (isLengthSelected || lengthList.length === 1) &&
    (isControlSelected || controlsList.length === 1) &&
    (skipLiningCheck || isLiningSelected || liningsList.length <= 1);
  const showJoinWaitlist =
    isWaitlist &&
    isProductConfigurationComplete &&
    (controlsList.length <= 1 || isControlConfirmed);

  let minPrice = Infinity;
  let maxPrice = -Infinity;
  let minDisPrice = Infinity;
  let maxDisPrice = -Infinity;
  if (isProductConfigurationComplete && activeProduct["Price"] > 0) {
    minPrice = activeProduct["Price"];
    maxPrice = activeProduct["Price"];
    minDisPrice = activeProduct["DiscountedPrice"];
    maxDisPrice = activeProduct["DiscountedPrice"];
  } else if (Array.isArray(catProducts)) {
    catProducts.forEach((product) => {
      minPrice = Math.min(minPrice, product.Price);
      maxPrice = Math.max(maxPrice, product.Price);
      minDisPrice = Math.min(minDisPrice, product.DiscountedPrice);
      maxDisPrice = Math.max(maxDisPrice, product.DiscountedPrice);
    });
  }

  return (
    <div
      className={
        `Product_Item_page_container Ready_made_drapery_page_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }` + ` ${location.pathname.split("/")[2]}`
      }
    >
      <div className="breadcrumb_container dir_ltr">
        <Breadcrumb className="breadcrumb">
          <Breadcrumb.Item
            linkAs={Link}
            className="breadcrumb_item"
            linkProps={{ to: "/" + pageLanguage, className: "breadcrumb_item" }}
          >
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item
            linkAs={Link}
            className="breadcrumb_item"
            linkProps={{
              to: "/" + pageLanguage + "/" + location.pathname.split("/")[2] + "/" + catID,
              className: "breadcrumb_item",
              preventScrollReset: true,
            }}
          >
            {CapitalizeAllWords(catObject["EnTitle"])}
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="rmd_product_area_container">
        <div className="rmd_title_mob_container mobile_only">
          <h1 className="rmd_title_mob">
            {pageLanguage === "fa" ? activeProduct["ProductName"] : activeProduct["ProductENName"]}{" "}
            {pageLanguage === "fa"
              ? activeProduct["SewingModelName"]
              : activeProduct["SewingModelEnName"]}
          </h1>
          <h2 className={`rmd_price_mob ${isSoldOut ? "sold_out_price" : ""}`}>
            {isSoldOut
              ? t("Sold Out")
              : activeProduct["Price"] > 0 &&
                GetPrice(activeProduct["Price"], pageLanguage, t("TOMANS"), isTabletOrMobile)}
          </h2>
        </div>
        <div className="rmd_left_side">
          <div className="rmd_sticky">
            <div className="rmd_vertical_carousel">
              <Splide
                ref={splideRef}
                options={{
                  height: "44rem",
                  width: "8rem",
                  rewind: false,
                  rewindByDrag: false,
                  direction: "ttb",
                  gap: "1.5rem",
                  type: "slide",
                  perPage: 5,
                  perMove: 1,
                  arrows: false,
                  pagination: false,
                  wheel: false,
                  updateOnMove: false,
                  focus: 0,
                }}
                aria-label="My Favorite Images"
              >
                {splidesList}
              </Splide>
            </div>
            <div className="rmd_images_container mobile_only">
              {!!slidesList.length && (
                <Carousel
                  variant="dark"
                  interval={null}
                  activeIndex={activeIndex}
                  controls={false}
                  touch={true}
                  onSelect={(eventKey) => setActiveIndex(eventKey)}
                >
                  {slidesList}
                </Carousel>
              )}
            </div>
            <div className="rmd_images_container desktop_only">
              <Carousel
                variant="dark"
                interval={null}
                activeIndex={activeIndex}
                controls={false}
                touch={true}
              >
                {slidesList}
              </Carousel>
            </div>
          </div>
        </div>
        <div className="rmd_right_side">
          <div className="rmd_info_container">
            <div className="rmd_info_title_container desktop_only">
              <h1 className="rmd_info_title title-rods">
                <p>
                  {pageLanguage === "fa"
                    ? activeProduct["ProductName"]
                    : activeProduct["ProductENName"]}
                </p>
                <p>
                  {pageLanguage === "fa"
                    ? activeProduct["SewingModelName"]
                    : activeProduct["SewingModelEnName"]}
                </p>
              </h1>
            </div>
            <div className="rmd_info_price_container desktop_only">
              {isSoldOut ? (
                <div className="rmd_info_price sold_out_price">{t("Sold Out")}</div>
              ) : (
              <div
                className="rmd_info_price"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <span style={minPrice === minDisPrice ? {} : { textDecoration: "line-through" }}>
                  {minPrice !== Infinity &&
                    maxPrice !== -Infinity &&
                    (minPrice === maxPrice
                      ? GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                      : pageLanguage === "fa"
                      ? GetPrice(maxPrice, pageLanguage, t(""), isTabletOrMobile) +
                        " - " +
                        GetPrice(minPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                      : GetPrice(minPrice, pageLanguage, t(""), isTabletOrMobile) +
                        " - " +
                        GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile))}
                </span>
                {minPrice !== minDisPrice && (
                  <span style={{ color: "#ca6667" }}>
                    {minDisPrice !== Infinity &&
                      maxDisPrice !== -Infinity &&
                      (minDisPrice === maxDisPrice
                        ? GetPrice(maxDisPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                        : pageLanguage === "fa"
                        ? GetPrice(
                            maxDisPrice,

                            pageLanguage,
                            t(""),
                            isTabletOrMobile
                          ) +
                          " - " +
                          GetPrice(minDisPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                        : GetPrice(minDisPrice, pageLanguage, t(""), isTabletOrMobile) +
                          " - " +
                          GetPrice(maxDisPrice, pageLanguage, t("TOMANS"), isTabletOrMobile))}
                  </span>
                )}

                {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                  <div className="products_list_item_body_desc_more_desc">
                    {i18n.language === "en" ? (
                      <>
                        {activeProduct["DiscountEnName"]}: {activeProduct["DiscountPercent"]}% off
                      </>
                    ) : (
                      <>
                        {activeProduct["DiscountName"]} :
                        {new Intl.NumberFormat("fa-IR").format(activeProduct["DiscountPercent"])} %
                        تخفیف
                      </>
                    )}
                  </div>
                )}
              </div>
              )}
            </div>
            <div className="rmd_info_colors_container">
              <div className="rmd_info_little_title_container">
                <h2 className="rmd_info_little_title">{t("Color: ")}</h2>
                {colorError && (
                  <h3 className="rmd_info_little_title error_text">{t("Select a color")}</h3>
                )}
                <h3 className="rmd_info_little_title">
                  {isColorSelected || colorsList.length === 1
                    ? pageLanguage === "fa"
                      ? activeProduct["ColorName"]
                      : capitalizeFirstLetters(activeProduct["ColorEnName"])
                    : ""}
                </h3>
              </div>
              <ul className={colorsList.length > 1 ? "rmd_info_colors_list" : "noDisplay"}>
                {colorsList}
              </ul>
            </div>
            {(location.pathname.split("/")[2] !== "ready-made-shade" ||
              (widthList.length === 1 && lengthList.length === 1)) && (
              <div className="rmd_info_size_container">
                <div className="rmd_info_little_title_container">
                  <h2 className="rmd_info_little_title">{t("Size: ")}</h2>
                  {isSoldOut && (
                    <h3 className="rmd_info_little_title error_text">{t("Sold Out")}</h3>
                  )}
                  {!isSoldOut && sizeError && (
                    <h3 className="rmd_info_little_title error_text">{t("Select a size")}</h3>
                  )}
                  <h3 className="rmd_info_little_title">
                    {!isSoldOut &&
                      (isSizeSelected || sizesList.length === 1
                        ? NumToFa(activeProduct["Width"] + t("Measurements CM"), pageLanguage) +
                          " x " +
                          NumToFa(activeProduct["Length"] + t("Measurements CM"), pageLanguage)
                        : "")}
                  </h3>
                </div>
                <ul
                  className={
                    sizesList.length > 1
                      ? `rmd_info_btn_list${isSoldOut ? " rmd_info_btn_list_disabled" : ""}`
                      : "noDisplay"
                  }
                >
                  {sizesList}
                </ul>
                <div className="rmd_info_size_guide">
                  <button
                    aria-expanded="false"
                    type="button"
                    className="btn image_plus_text_btn"
                    onClick={() => {
                      modalHandleShow("measurementsHelp");
                    }}
                  >
                    <div className="ruler_img img-fluid" />
                    <p className="text_underline">{t("Measuring Guide")}</p>
                  </button>
                </div>
              </div>
            )}

            {location.pathname.split("/")[2] === "ready-made-shade" &&
              (widthList.length > 1 || lengthList.length > 1) && (
                <>
                  <div className="rmd_info_size_container">
                    <div className="rmd_info_little_title_container">
                      <h2 className="rmd_info_little_title">{t("Width: ")}</h2>
                      {isSoldOut && (
                        <h3 className="rmd_info_little_title error_text">{t("Sold Out")}</h3>
                      )}
                      {!isSoldOut && !isWidthSelected && (
                        <h3 className={`rmd_info_little_title ${widthError ? "error_text" : ""}`}>
                          {t("Select a width")}
                        </h3>
                      )}
                      <h3 className="rmd_info_little_title">
                        {!isSoldOut && isWidthSelected
                          ? NumToFa(activeProduct["Width"] + t("Measurements CM"), pageLanguage)
                          : ""}
                      </h3>
                    </div>
                    <ul
                      className={
                        widthList.length > 0
                          ? `rmd_info_btn_list rmd_max_list${
                              isSoldOut ? " rmd_info_btn_list_disabled" : ""
                            }`
                          : "noDisplay"
                      }
                    >
                      {widthList}
                    </ul>
                  </div>
                  <div className="rmd_info_size_container">
                    <div className="rmd_info_little_title_container">
                      <h2 className="rmd_info_little_title">{t("Length: ")}</h2>
                      {isSoldOut && (
                        <h3 className="rmd_info_little_title error_text">{t("Sold Out")}</h3>
                      )}
                      {!isSoldOut && !isLengthSelected && (
                        <h3 className={`rmd_info_little_title ${lengthError ? "error_text" : ""}`}>
                          {t("Select a length")}
                        </h3>
                      )}
                      <h3 className="rmd_info_little_title">
                        {!isSoldOut && isLengthSelected
                          ? NumToFa(activeProduct["Length"] + t("Measurements CM"), pageLanguage)
                          : ""}
                      </h3>
                    </div>
                    <ul
                      className={
                        lengthList.length > 0
                          ? `rmd_info_btn_list rmd_max_list${
                              isSoldOut ? " rmd_info_btn_list_disabled" : ""
                            }`
                          : "noDisplay"
                      }
                    >
                      {lengthList}
                    </ul>
                    <div className="rmd_info_size_guide">
                      <button
                        aria-expanded="false"
                        type="button"
                        className="btn image_plus_text_btn"
                        onClick={() => {
                          modalHandleShow("measurementsHelp");
                        }}
                      >
                        <div className="ruler_img img-fluid" />
                        <p className="text_underline">{t("Measuring Guide")}</p>
                      </button>
                    </div>
                  </div>
                </>
              )}
            {activeProduct["ProductGroupId"] === "100205" && liningsList.length > 1 && (
              <div className="rmd_info_lining_container">
                <div className="rmd_info_little_title_container">
                  <h2 className="rmd_info_little_title">{t("Lining: ")}</h2>
                  {isSoldOut && (
                    <h3 className="rmd_info_little_title error_text">{t("Sold Out")}</h3>
                  )}
                  {!isSoldOut && !isLiningSelected && (
                    <h3 className={`rmd_info_little_title ${liningError ? "error_text" : ""}`}>
                      {t("Select a lining")}
                    </h3>
                  )}
                  <h3 className="rmd_info_little_title">
                    {!isSoldOut &&
                      (isLiningSelected || liningsList.length <= 1
                        ? pageLanguage === "fa"
                          ? activeProduct["LiningTypeName"]
                          : activeProduct["LiningTypeEnName"]
                        : "")}
                  </h3>
                </div>
                <ul
                  className={
                    liningsList.length > 1
                      ? `rmd_info_btn_list${isSoldOut ? " rmd_info_btn_list_disabled" : ""}`
                      : "noDisplay"
                  }
                >
                  {liningsList}
                </ul>
              </div>
            )}
            {location.pathname.split("/")[2] === "ready-made-shade" && controlsList.length > 1 && (
              <>
                <div className="rmd_info_control_container">
                  <div className="rmd_info_little_title_container">
                    <h2 className="rmd_info_little_title">{t("Control Position: ")}</h2>
                    {isSoldOut && (
                      <h3 className="rmd_info_little_title error_text">{t("Sold Out")}</h3>
                    )}
                    {!isSoldOut && !isControlConfirmed && (
                      <h3 className={`rmd_info_little_title ${controlError ? "error_text" : ""}`}>
                        {t("Select a control position")}
                      </h3>
                    )}
                    <h3 className="rmd_info_little_title">
                      {!isSoldOut && isControlConfirmed
                        ? pageLanguage === "en"
                          ? controlPositionText
                          : controlPositionText === "Left"
                          ? "چپ"
                          : controlPositionText === "Right"
                          ? "راست"
                          : controlPositionText
                        : ""}
                    </h3>
                  </div>
                  <ul
                    className={
                      controlsList.length > 0
                        ? `rmd_info_colors_list${isSoldOut ? " rmd_info_btn_list_disabled" : ""}`
                        : "noDisplay"
                    }
                  >
                    {controlsList}
                  </ul>
                </div>
              </>
            )}
            <div className="rmd_info_qty_container">
              <div className="rmd_info_little_title_container">
                <h2 className="rmd_info_little_title">{t("QTY: ")}</h2>
                {isOverStock && (
                  <h3 className="rmd_info_little_title error_text">
                    {t("We only have {{count}} QTY available.", {
                      count: NumToFa(stockQty, pageLanguage),
                    })}
                  </h3>
                )}
              </div>
              <span className="basket_item_qty">
                <QtyCountFabric
                  qty={qty}
                  setQty={setQty}
                  minQty={1}
                  maxQty={fabricMaxQty}
                  steps={fabricSteps}
                  isReadOnly={true}
                  disabled={isSoldOut}
                  pageLanguage={pageLanguage}
                  NumberToPersianWord={NumberToPersianWord}
                />
              </span>
            </div>
            <div className="rmd_info_btn_container bag_buttons_section_container">
              <div className="join_waitlist_action_block">
                {showJoinWaitlist && showWaitlistEmail && (
                  <input
                    type="email"
                    className="join_waitlist_email_input"
                    placeholder={t("Your email address")}
                    value={waitlistEmail}
                    onChange={(e) => {
                      setWaitlistEmail(e.target.value);
                      if (waitlistEmailError) setWaitlistEmailError("");
                    }}
                  />
                )}
                <button
                  className="btn add_to_cart"
                  onClick={() => {
                    if (isSoldOut || isOverStock) return;
                    if (showJoinWaitlist) {
                      if (!showWaitlistEmail) {
                        setShowWaitlistEmail(true);
                        return;
                      }
                      joinWaitingList();
                      return;
                    }
                    if (
                      (widthList.length > 1 || lengthList.length > 1) &&
                      (!isWidthSelected || !isLengthSelected)
                    ) {
                      setWidthError(true);
                      setLengthError(true);
                      setControlError(true);
                      setLiningError(true);
                      return;
                    }

                    if (
                      !skipLiningCheck &&
                      liningsList.length > 1 &&
                      !isLiningSelected &&
                      activeProduct.SewingModelId !== "0324"
                    ) {
                      setLiningError(true);
                      return;
                    }
                    if (controlsList.length > 1 && !isControlConfirmed) {
                      setControlError(true);
                      return;
                    }
                    setAddingLoading(true);
                    addProduct(activeProduct, qty);
                  }}
                  disabled={
                    isSoldOut ||
                    isOverStock ||
                    addingLoading ||
                    savingLoading ||
                    removingLoading ||
                    waitlistLoading
                  }
                >
                  {isSoldOut
                    ? t("Sold Out")
                    : isOverStock
                    ? t("NOT AVAILABLE")
                    : showJoinWaitlist
                    ? waitlistLoading
                      ? t("ADDING...")
                      : t("JOIN WAITLIST")
                    : addingLoading
                    ? t("ADDING...")
                    : t("footer_Add To Cart")}
                </button>
                {showJoinWaitlist && waitlistEmailError && (
                  <div
                    className={`join_waitlist_message ${
                      waitlistMessageType === "success"
                        ? "join_waitlist_message_success"
                        : "join_waitlist_message_error"
                    } ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
                  >
                    {waitlistEmailError}
                  </div>
                )}
              </div>
              <button
                className="save_to_acc white_btn btn"
                onClick={() => {
                  if (isPageComplete) {
                    saveProduct(activeProduct, true);
                  } else {
                    saveProduct(activeProduct, false);
                  }
                }}
                disabled={addingLoading || savingLoading || removingLoading || waitlistLoading}
              >
                <img
                  src={
                    userFavorites.findIndex(
                      (obj) =>
                        obj.ProductId === activeProduct["ProductId"] &&
                        obj.IsComplete === isPageComplete
                    ) > -1
                      ? require("../Images/public/favorite_filled.png")
                      : require("../Images/public/favorite.png")
                  }
                  className="img-fluid"
                  alt=""
                />
                {savingLoading
                  ? t("SAVING...")
                  : removingLoading
                  ? t("REMOVING...")
                  : t("product_Save_To_wishlist")}
              </button>
            </div>
            <div className="rmd_info_desc_container">
              <Accordion>
                <Accordion.Item eventKey="0">
                  <ContextAwareToggleFilters
                    eventKey="0"
                    textOnHide={t("Product Description")}
                    textOnShow={t("Product Description")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["DescriptionEn"]
                          : convertToPersian(activeProduct["Description"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Dimensions")}
                    textOnShow={t("Dimensions")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["DimensionEn"]
                          : convertToPersian(activeProduct["Dimension"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <ContextAwareToggleFilters
                    eventKey="2"
                    textOnHide={t("Materials & Care")}
                    textOnShow={t("Materials & Care")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["MatrialCareEn"]
                          : convertToPersian(activeProduct["MatrialCare"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <ContextAwareToggleFilters
                    eventKey="3"
                    textOnHide={t("Shipping & Returns")}
                    textOnShow={t("Shipping & Returns")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["ShippingReturnEn"]
                          : convertToPersian(activeProduct["ShippingReturn"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["cart_modal"] === undefined ? false : modals["cart_modal"]}
        onHide={() => {
          modalHandleClose("cart_modal");
        }}
        id="cart_modal"
      >
        <div className="custom_cart_header_desc">{`${
          freeShipPrice - sideCartPrice > 0
            ? `${t("cart_agree_free_ship1")}${
                pageLanguage === "fa"
                  ? NumberToPersianWord.convertEnToPe(
                      `${GetPrice(
                        freeShipPrice - sideCartPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )}`
                    )
                  : GetPrice(
                      freeShipPrice - sideCartPrice,
                      pageLanguage,
                      t("TOMANS"),
                      isTabletOrMobile
                    )
              }${t("cart_agree_free_ship2")}`
            : `${t("cart_agree_free_ship")}`
        }`}</div>
        <Modal.Header>
          <span className="custom_cart_title">
            {t("My Bag")}
            <h3>
              (
              {pageLanguage === "fa"
                ? NumberToPersianWord.convertEnToPe(`${cartCount}`)
                : cartCount}
              )
            </h3>
          </span>
          <button
            className="custom_cart_close"
            onClick={() => {
              modalHandleClose("cart_modal");
              sessionStorage.clear();
              // navigate("/" + pageLanguage);
            }}
          >
            {t("CONTINUE SHOPPING")}
          </button>
        </Modal.Header>
        <Modal.Body>
          <RenderSideCart cartObjects={sideCartObjects} setCartCount={setCartCount} />
        </Modal.Body>
        <Modal.Footer>
          <div className="go_to_checkout" style={{backgroundColor: "#faf9f7"}}>
            <div className="checkout_button_section small_checkout_button_section">
              <div className="small_cart_price_summary">
                {
                  sideCartProductTotal > 0 && (
                    <span className="checkout_payment_price_detail payment_price_detail" style={{marginTop:"0.7rem"}}>
                  <h3>{t("PRODUCT TOTAL")}</h3>
                  <h4>
                    {GetPrice(sideCartProductTotal, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                  </h4>
                </span>
                  )
                }
               
                {sideCartInstallPrice > 0 && (
                  <span className="checkout_payment_price_detail payment_price_detail">
                    <h3>{t("INSTALLATION SERVICES")}</h3>
                    <h4>
                      {GetPrice(sideCartInstallPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                    </h4>
                  </span>
                )}
                {sideCartTransportPrice > 0 && (
                  <span className="checkout_payment_price_detail payment_price_detail">
                    <h3>{t("TRANSPORTATION FEE")}</h3>
                    <h4>
                      {GetPrice(
                        sideCartTransportPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )}
                    </h4>
                  </span>
                )}
                {(sideCartHasSwatches ||
                  sideCartProductTotal > 0 ||
                  sideCartInstallPrice > 0 ||
                  sideCartTransportPrice > 0) && (
                  <span className="checkout_payment_price_detail payment_price_detail">
                    <h3>{t("SHIPPING")}</h3>
                    <h4>
                      {freeShipPrice > 0 &&
                      (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                        ? t("FREE")
                        : t("CALCULATED AT CHECKOUT")}
                    </h4>
                  </span>
                )}
              </div>
              <span className="checkout_payment_price_detail payment_price_detail small_cart_subtotal">
              <h3>
                 {freeShipPrice > 0 &&
                (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                 ? t("TOTAL")
               : t("SUBTOTAL")}
              </h3>
                <h4>
                  {GetPrice(
                    isLoggedIn
                      ? sideCartPrice
                      : sideCartProductTotal + sideCartInstallPrice + sideCartTransportPrice,
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  )}
                </h4>
              </span>
              <Link className="basket_checkout btn" to={"/" + pageLanguage + "/Basket"}>
                {t("CHECKOUT")}
              </Link>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`measurementsHelp_modal largeSizeModal scroll_on ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["measurementsHelp"] === undefined ? false : modals["measurementsHelp"]}
        onHide={() => modalHandleClose("measurementsHelp")}
        scrollable={true}
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <StaticMeasureHelps SewingModelId={activeProduct["SewingModelId"]} />
          <div className="text_center">
            <button
              className="btn btn-new-dark"
              onClick={() => modalHandleClose("measurementsHelp")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["add_to_project_modal"] === undefined ? false : modals["add_to_project_modal"]}
        onHide={() => {
          modalHandleClose("add_to_project_modal");
        }}
        id="add_to_project_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="add_to_project_container">
            <h2 className="project_added_text">{t("1 ITEM ADDED TO YOUR FAVORITES")}</h2>
            <Link className="add_to_project_btn btn" to={"/" + pageLanguage + "/Account/Favorites"}>
              {t("VIEW FAVORITES")}
            </Link>
            <button
              className="continue_shopping_btn"
              onClick={() => {
                modalHandleClose("add_to_project_modal");
              }}
            >
              {t("CONTINUE SHOPPING")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <ToastContainer
        className={`position_fixed favorite_saved ${toastSave ? "" : "favorite_removed"}`}
        position="top-end"
      >
        <Toast
          onClose={() => setShowToast(false)}
          bg="Light"
          show={showToast}
          delay={5000}
          autohide
        >
          <Toast.Body>
            <div className="favorite_toast_container">
              <div className="favorite_toast_title">
                {toastSave ? t("Added to Favorites") : t("Removed from Favorites")}
              </div>
              <div className="favorite_toast_details">
                <img
                  src={imgUrl(
                    activeProduct["Photos"]?.find((obj) => obj.PhotoTypeId === 4709)?.PhotoUrl || ""
                  )}
                  alt=""
                  className="favorite_toast_img img-fluid"
                />
                <div className="favorite_toast_name">
                  {pageLanguage === "fa"
                    ? activeProduct["ProductName"]
                    : activeProduct["ProductENName"]}{" "}
                  {pageLanguage === "fa"
                    ? activeProduct["SewingModelName"]
                    : activeProduct["SewingModelEnName"]}
                </div>
              </div>
              <div className="button_section">
                <Link className="save_to_fav white_btn " to={"/" + pageLanguage + "/Favorites"}>
                  {t("VIEW FAVORITES")}
                </Link>
              </div>
            </div>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}

export default ReadyMadeDraperyItem;